import { OnInit, Component, Input } from "@angular/core";
import { IAssessment, INoctiAssessment, IWorksiteAssessment, IObservationalAssessment, IDisabilityBenefit } from "./models/assessment";
import { AssessmentService } from "./services/assessment.service";
import { IAssessmentQuestion } from "./models/assessmentQuestion";
import { UsersService } from "../../services/users.service";
import { map } from "rxjs/operators";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "assessment-list",
  templateUrl: "./assessment-list.component.html",
  styleUrls: ["./assessment.component.css"]
})
export class AssessmentListComponent implements OnInit {

  cisSkillsUrl: string = "https://apps.illinoisworknet.com/cisskills/Redirect.aspx";
  dwAppsUrl: string = "https://www.illinoisworknet.com/disabilityworks/Tools/Pages/LoggedInEstimator.aspx";  
  selfEvalUrl: string = "";

  loading: boolean;
  cisLink: string = null;
  userEmail: string = "";

  noctiAssessments: INoctiAssessment[];
  selfAssessments: IWorksiteAssessment[];
  worksiteAssessments: IWorksiteAssessment[];
  observationalAssessments: IObservationalAssessment[];
  dwResults: IDisabilityBenefit[];

  @Input() assessments: Array<IAssessment> = [];
  @Input() columns: string[];
  assessmentQuestions: Array<IAssessmentQuestion> = [];

  constructor(private _assessmentSrvc: AssessmentService, private _commonSrv: CommonService) {
  }

  ngOnInit(): void {
    this.columns = ["Assessment Type", "Score", "Date Taken", "View Results"];
    this.getUserEmail();

    this.getOnlyAssessment();
    this.getCISAssessment();
    this.getNoctiAssessment();
    this.GetSelfEvalResults();
    this.GetWorksiteResults();
    this.GetObservationalResults();
  }

  getUserEmail() {
    this._commonSrv.emailAddress().subscribe(result => {
      if (result != null) {
        this.userEmail = result;
      }
    });
  }

  getOnlyAssessment() {
    this._assessmentSrvc.getOnlyAssessment().subscribe(result => {
      if (result != null) {
        this.assessments = result;
      }
    });
  }

  getCISAssessment() {
    this._assessmentSrvc.getCISAssessment().subscribe(result => {
      if (result != null) {
        this.cisLink = result;
      }
    });
  }

  getNoctiAssessment() {
    this._assessmentSrvc.getNoctiAssessments().subscribe(result => {
      if (result != null) {
        this.noctiAssessments = result;
      }
    });
  }

  GetSelfEvalResults() {
    this._assessmentSrvc.getSelfEvalAssessments().subscribe(result => {
      if (result != null) {
        this.selfAssessments = result;

        this.selfAssessments.forEach(x => {

          x.evalUrl = x.evalUrl.replace("amp;", "");

        });
      }
    });
  }

  GetWorksiteResults() {
    this._assessmentSrvc.getWorksiteAssessments().subscribe(result => {
      if (result != null) {
        this.worksiteAssessments = result;
      }
    });
  }

  GetObservationalResults() {
    this._assessmentSrvc.getObservationalAssessments().subscribe(result => {
      if (result != null) {
        this.observationalAssessments = result;
      }
    });
  }

  GetDisabilityResults() {
    this._assessmentSrvc.getDisablityAssessments().subscribe(result => {
      if (result != null) {
        this.dwResults = result;
      }
    });
  }

  downloadCertification() {
    this._assessmentSrvc.downloadCertification();
  }
}
